require('../../reports/_reportTitle');
const songSample = require('./_songSample');

$(() => {
  let currentPage = 1;
  let lastFocusedSearchType = '';
  let pendingRequest = false;
  let addToListIds = {};
  let openBrowseBy = null;
  let maxPages;
  let elementClicked = null;
  let refineSearch = {};
  let searchType = '';
  let dataArr = [];

  document.addEventListener('mousedown', (e) => {
    e = e || window.event;
    const target = e.target || e.srcElement;
    elementClicked = target;
  }, false);

  populateFormFromGet();

  $(document).delegate('body', 'click', (e) => {
    $('[data-toggle="popover"]').each(function () {
      if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
        $(this).on('hidden.bs.popover', function () {
          $(this).parent().find('div.popover').hide();
        });
        $(this).popover('hide');
      }
    });
  });

  $('.search-music-results').delegate('.file-image, .file-preview, .file-listen, .file-read, .file-tif, .file-pdf', 'click', function (e) {
    const filename = $(this).data('filename');
    const idHymn = $(this).data('id');
    const idSong = $(this).data('idSong');
    const type = $(this).data('type');

    $.post(urlLogFileActivity, {
      filename,
      idHymn,
      id: idSong,
      type

    }, (data) => {

    });
  });

  $('.search-music-results').on('click', '.file-tif, .file-pdf', function (e) {
    const url = $(this).attr('href');

    document.cookie = 'fileDownload=; Max-Age=0';

    $.fileDownload(url, {
      successCallback(url) {

      },
      failCallback(responseHtml, url) {
        alert('Oops! It looks like that file is currently unavailable. Don\'t worry, the Member Publisher has been notified and a fix is on the way.');
      }
    });

    return false;
  });

  $('.search-music-results').delegate('.sku', 'click', function (e) {
    e.preventDefault();

    const $temp = $('<input>');
    $('body').append($temp);
    $temp.val($(this).data('sku')).select();
    document.execCommand('copy');
    $temp.remove();

    toastr.success('SKU Copied to clipboard');
  });

  $('.select-template').select2({
    placeholder: 'Select List',
    minimumResultsForSearch: Infinity
  });

  if ($('.select-licenseType').length) {
    $('.time-report').select2({
      placeholder: 'Select Week',
      minimumResultsForSearch: Infinity,
      disabled: true
    });
  } else {
    $('.time-report').select2({
      placeholder: 'Select Week',
      minimumResultsForSearch: Infinity

    });
  }

  $('.select-licenseType').select2({
    placeholder: 'Select License Type',
    minimumResultsForSearch: Infinity
  });

  $('select#graphic_source').select2({
    placeholder: 'Select Graphic Source',
    minimumResultsForSearch: Infinity
  });

  $('.select-licenseType').on('select2:select', function (e) {
    const id = $(this).find('option:selected').val();
    const timeReportSelect = $(this).closest('form').find('.time-report');
    const $this = $(this);

    timeReportSelect.select2('val', '');
    timeReportSelect.select2({
      disabled: true,
      minimumResultsForSearch: Infinity,
      placeholder: 'loading...'
    });

    $.post(loadWeeksUrl, {
      id
    }, (data) => {
      timeReportSelect.find('option').remove();

      $.each(data.weeks, (i, item) => {
        timeReportSelect.append($('<option>', {
          value: i,
          text: item
        }));
      });

      timeReportSelect.select2({
        disabled: false,
        minimumResultsForSearch: Infinity
      });

      $this.trigger('weeks-loaded');
    }, 'json');
  });

  $('.next-page').click((e) => {
    if (!pendingRequest && parseInt(currentPage) < parseInt(maxPages)) {
      currentPage++;
      $('#searchForm').submit();
    }

    e.preventDefault();
  });

  $('.previous-page').click((e) => {
    if (!pendingRequest && parseInt(currentPage) > 1) {
      currentPage--;
      $('#searchForm').submit();
    }

    e.preventDefault();
  });

  $('.page-number-input').donetyping(function () {
    const nextPage = parseInt($(this).val());

    if (!isNaN(nextPage)) {
      if (nextPage >= 1 && nextPage <= maxPages) {
        currentPage = nextPage;
        $('#searchForm').submit();
      }
    } else {
      $(this).val(currentPage);
    }
  });

  /* ADD TO LIST */
  $('#addToListForm').submit((e) => {
    e.preventDefault();
  });

  $('#submit-view').click(() => {
    $('#addToListAlert').hide();

    const form = $('#addToListForm');
    dataArr = form.serializeArray();

    $('#addToListModal').find('button').button('loading');

    $.post(saveAsListUrl, {
      titles: addToListIds,
      dataArr
    }, (data) => {
      $('#addToListModal').find('button').button('reset');

      if (data.isError == 1) {
        $('#addToListAlert').html(data.msgError);
        $('#addToListAlert').show();
      } else {
        addToListIds = {};
        /* redirect to url from response */
        window.location.href = `${redirectToListUrl}?id=${data.idList}`;
      }
    });
  });

  $('.previous-page').click((e) => {
    if (!pendingRequest && parseInt(currentPage) > 1) {
      currentPage--;
      $('#searchForm').submit();
    }

    e.preventDefault();
  });

  $('#submit-continue').click(() => {
    $('#addToListAlert').hide();

    const form = $('#addToListForm');
    dataArr = form.serializeArray();

    $('#addToListModal').find('button').button('loading');

    $.post(saveAsListUrl, {
      titles: addToListIds,
      dataArr
    }, (data) => {
      $('#addToListModal').find('button').button('reset');

      if (data.isError == 1) {
        $('#addToListAlert').html(data.msgError);
        $('#addToListAlert').show();
      } else {
        /* update select with new list */
        if (data.newList == 1) {
          const listOption = $('<option>').attr('value', data.idList).html(data.title);

          $('#addToListModal').find('select[name="list-id"]').append(listOption);
        }

        addToListIds = {};
        $('#addToListModal').modal('hide');
      }
    });
  });

  $('#addToListModal').on('hide.bs.modal', (e) => {
    addToListIds = {};
  });

  $('#addToListModal').on('show.bs.modal', (e) => {
    $('#addToListAlert').hide();

    $('.select-template').select2('val', '');
    $('#addToListModal input[name="list-name"]').val('');
  });
  /* END ADD TO LIST */

  $('#searchForm').submit(function (e) {
    if (!pendingRequest) {
      pendingRequest = true;

      songSample.resetSample();

      /* this is important in case if user push
             enter on keyboard to let know backend which
             type of search to perform */
      let lastFocused = $(this.id).context.activeElement;
      if ($(lastFocused).attr('name') == 'term') {
        searchType = $(lastFocused).attr('name');
      } else if ($(lastFocused).attr('id') == 'next-page' || $(lastFocused).attr('id') == 'previous-page') {
        /* fix for double loading first page for term/hymn search */
        searchType = '';
      } else {
        lastFocused = elementClicked;
        searchType = (typeof lastFocused == 'undefined' || lastFocused == null) ? '' : $(lastFocused).attr('name');
      }

      if (
        searchType != 'submit-term'
                && searchType != 'term'
                && $('#hidden-type').length > 0
      ) {
        searchType = $('#hidden-type').val();
      } else {
        $('#hiddenInputs').html('');

        $('.browse-by:visible').slideToggle(300);

        if (searchType != 'submit-term') {
          switch (searchType) {
            case 'term':
              currentPage = 1;
              searchType = 'submit-term';
              lastFocusedSearchType = 'submit-term';
              break;
            default:
              searchType = lastFocusedSearchType;
          }
        } else {
          currentPage = 1;
          lastFocusedSearchType = searchType;
        }
      }

      $('#search-overlay').show();
      $(this).find('button').button('loading');

      const form = $(this);
      dataArr = $(this).serializeArray();

      $.post(urlLoadSearchResults, {
        dataArr,
        searchType,
        page: currentPage,
        refineSearch
      }, (data) => {
        pendingRequest = false;

        if (openBrowseBy != null) {
          const id = `#${openBrowseBy}`;
          $('#browseby li').removeClass('active');
          $(`#browseby li[data-target="${id}"]`).addClass('active');

          toggleElementWithOtherElement(id, 'div.browse-by');

          openBrowseBy = null;
        }

        $('#search-overlay').hide();
        form.find('button').button('reset');

        if (data.isError === 1) {
          alert(data.msgError);
        } else {
          if (data.results > 0) {
            $('#btnReportAllSelectedSongs').show();
          } else {
            $('#btnReportAllSelectedSongs').hide();
          }

          maxPages = data.pages;


          const term = $('#searchForm input[name="term"]').val();

          $('#submission-title').attr('href', function () {
            const url = this.href.split('?')[0];
            return `${url}?term=${term}`;
          });

          $('#page-count').html(`of ${data.pages}`);

          $('div.result-info, div.result-info2').show();
          $('div.not-find-info').show();
          $('.search-music-wrapper .search-music-results').html(data.html);

          $('.page-number-input').val(data.currentPage);

          if (parseInt(data.pages) > 0) {
            $('div.page-pagination-div').show();
          } else {
            $('div.page-pagination-div').hide();
          }

          populateRefineSearchBadges();

          $('[data-toggle="popover"]').popover({
            placement: 'top',
            html: true,
            content: `${'<div class="row"><div class="col-xs-12"><p>PDF and TIFF files are available to license holders to make creating worship aids easy!</p></div>'
                        + '<div class="col-xs-12 col-sm-7 padding-left-0 padding-right-0"> <a href="'}${purchaseLoginUrl}" class="btn btn-block btn-green btn-thin ">Purchase License</a></div>`
                        + `<div class="col-xs-12 col-sm-5"><a href="${loginUrl}" class="btn btn-block btn-brown-thin">Login</a></div> </div>`
          });
        }

        /* build current search url */
        let formTerm = $('input[name="term"]').val();
        let formHiddenVal = $('input[name="hidden-value"]').val();

        const searchParams = {
          term: formTerm,
          page: currentPage,
          type: searchType
        };

        $.each(refineSearch, (filterId, filterObject) => {
            $.each(filterObject, (type, value) => {
                const filter = encodeURIComponent(value);

                if (!(type in searchParams)) searchParams[type] = filter;
                else searchParams[type] += `&&${filter}`;
            });
        });

        if (formTerm != '' || (formHiddenVal != '' && formHiddenVal != null)) {
          formTerm = encodeURIComponent(formTerm);
          formHiddenVal = encodeURIComponent(formHiddenVal);

          history.pushState({}, null, `${urlSearch}?${jQuery.param(searchParams)}`);
        }
      });
    }

    e.preventDefault();
  });

  $('#searchForm').submit();

  $('.search-music-results').delegate('a.link-collapse', 'click', function () {
    if ($(this).find('span.title-collapse').html() == 'Close Downloadable Files') {
      $(this).find('img').attr('src', '/images/arrow-bottom-01.png');
      $(this).find('span.title-collapse').html('View more versions');
    } else {
      $(this).find('img').attr('src', '/images/arrow-top-01.png');
      $(this).find('span.title-collapse').text('Close Downloadable Files');
    }
  });

  function populateFormFromGet() {
    const params = {};
    const url = window.location.href;

    url.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
      key = decodeURIComponent(key);
      value = decodeURIComponent(value.replace(/\+/g, '%20'));
      params[key] = value;
    });

    if ('term' in params) {
      const term = decodeURIComponent(params.term);
      $('input[name="term"]').val(term);
    }
    if ('page' in params) currentPage = params.page;
    if ('type' in params) lastFocusedSearchType = params.type;
    if ('contributor' in params) refineByArray('contributor', decodeURIComponent(params.contributor).split('&&'));
    if ('psalm' in params) refineSearch.psalm = decodeURIComponent(params.psalm);
    if ('tune' in params) refineSearch.tune = decodeURIComponent(params.tune);
    if ('meter' in params) refineSearch.meter = decodeURIComponent(params.meter);
    if ('publisher' in params) refineSearch.publisher = decodeURIComponent(params.publisher);


    if ('open' in params) openBrowseBy = params.open;
  }

  $('#listen-modal').on('show.bs.modal', function (e) {
    const btn = $(e.relatedTarget);
    const url = btn.parent().data('url');
    const title = btn.parent().data('title');

    $(this).find('h4').html(title);
    $(this).find('audio').attr('src', url);
  });

  $('#preview-modal').on('show.bs.modal', function (e) {
    const btn = $(e.relatedTarget);

    const url = btn.data('url');
    const title = btn.data('title');

    imageHtml = `<img src="${url}" />`;

    $(this).find('h4').html(title);
    $(this).find('.preview-img-cnt').html(imageHtml);
  });

  $('#addToListModal').on('show.bs.modal', (e) => {
    const btn = $(e.relatedTarget);

    $('#atl-title').html(`"${btn.data('title')}"`);
    $('#atl-subtitle').html(btn.data('subtitle'));

    addToListIds[btn.data('id-item')] = btn.data('title');
  });

  $('#reportModal').on('show.bs.modal', (e) => {
    const btn = $(e.relatedTarget);

    $('#r-title').html(`"${btn.data('title')}"`);
    $('#r-subtitle').html(btn.data('subtitle'));
    $('#r-detail').html(btn.data('detail'));
    $('#r-tune').html(btn.data('tune'));
  });

  $('#reportAllModal').on('show.bs.modal', function (e) {
    let titles = '';
    let titlesNumber = 0;

    $('input.report-checkbox').each(function () {
      if ($(this).is(':checked')) {
        titlesNumber++;
        titles += `<h4 class="text-center">${$(this).data('title')}</h4>`;
      }
    });

    if (titlesNumber == 0) {
      $('#report-titles-body').hide();
      $('#report-no-titles-body').show();
    } else {
      $('#titles-number').html(titlesNumber);
      $('#report-titles-list').html(titles);

      $('#report-titles-body').show();
      $('#report-no-titles-body').hide();
    }

    const lastSelectedWeek = localStorage.getItem('lastSelectedWeek');

    if (lastSelectedWeek) $(this).find('.time-report').val(lastSelectedWeek).trigger('change');
  });

  /* BEGIN BROWSE BY */
  $('#browseby li').click(function () {
    const id = $(this).data('target');
    $('#browseby li').removeClass('active');

    $(this).addClass('active');

    toggleElementWithOtherElement(id, 'div.browse-by');
  });

  $('#browse-by-letters button').click(function () {
    $('#browse-by-letters button').removeClass('btn-active');
    $('#browse-by-letters button').addClass('btn-default');

    $(this).removeClass('btn-default');
    $(this).addClass('btn-active');

    performSearchBy('letter', $(this).text());
  });

  $('#browse-by-contributor button').click(function () {
    $('#browse-by-contributor button').removeClass('btn-active');
    $('#browse-by-contributor button').addClass('btn-default');

    $(this).removeClass('btn-default');
    $(this).addClass('btn-active');

    const letter = $(this).text();

    if ($(`#contributor-list-${letter}`).length > 0) {
      /* toggle box */
      toggleElementWithOtherElement(`#contributor-list-${letter}`, 'div.contributor-list-cnt');
    } else {
      /* load contributors */
      $.post(loadContributorListUrl, {
        data: letter
      }, (data, b) => {
        if (data.isError == 1) {
          alert(data.msgError);
        } else {
          const cntContributor = $('<div>')
              .attr('id', `contributor-list-${letter}`)
              .attr('style', 'display: none;')
              .addClass('contributor-list-cnt')
              .addClass('margin-horizontal-15')
              .html(data.html);

          $('#browse-by-contributor-lists').append(cntContributor);

          toggleElementWithOtherElement(`#contributor-list-${letter}`, 'div.contributor-list-cnt');
        }
      });
    }
  });

  $('#browse-by-contributor-lists').delegate('a', 'click', function (e) {
    const value = `${$(this).data('name')}\\${$(this).data('id-contributor')}`;

    refineSearchBy('contributor', value);
    $('#searchForm').submit();

    /* hide contributor list when search performed */
    $('div.contributor-list-cnt:visible').slideToggle(300);

    e.preventDefault();
  });

  $('#browse-by-tune button').click(function () {
    $('#browse-by-tune button').removeClass('btn-active');
    $('#browse-by-tune button').addClass('btn-default');

    $(this).removeClass('btn-default');
    $(this).addClass('btn-active');

    const letter = $(this).text();

    if ($(`#tune-list-${letter}`).length > 0) {
      /* toggle box */
      toggleElementWithOtherElement(`#tune-list-${letter}`, 'div.tune-list-cnt');
    } else {
      /* load contributors */
      $.post(loadTuneListUrl, {
        data: letter
      }, (data, b) => {
        if (data.isError == 1) {
          alert(data.msgError);
        } else {
          const cntTune = $('<div>')
              .attr('id', `tune-list-${letter}`)
              .attr('style', 'display: none;')
              .addClass('tune-list-cnt')
              .addClass('margin-horizontal-15')
              .html(data.html);

          $('#browse-by-tune-lists').append(cntTune);

          toggleElementWithOtherElement(`#tune-list-${letter}`, 'div.tune-list-cnt');
        }
      });
    }
  });
  $('#browse-by-tune-lists').delegate('a', 'click', function (e) {
    refineSearchBy('tune', $(this).data('tune-name'));

    /* hide contributor list when search performed */
    $('div.tune-list-cnt:visible').slideToggle(300);

    e.preventDefault();
  });

  $('#toggle-publisher-list').click(() => {
    $('#browse-by-publisher-list').slideToggle(300);
  });
  $('#browse-by-publisher-list a').click(function (e) {
    const value = `${$(this).data('publisher')}\\${$(this).data('id-publisher')}`;

    refineSearchBy('publisher', value);

    /* hide list when search performed */
    $('#browse-by-publisher-list:visible').slideToggle(300);

    e.preventDefault();
  });

  $('#toggle-meter-list').click(() => {
    $('#browse-by-meter-list').slideToggle(300);
  });

  $('#browse-by-meter-list a').click(function (e) {
    refineSearchBy('meter', $(this).data('meter'));

    /* hide list when search performed */
    $('#browse-by-meter-list:visible').slideToggle(300);

    e.preventDefault();
  });

  $('#submit-search-by-psalm').click(function () {
    const value = $(this).parent().parent().find('input')
        .first()
        .val();

    if (value.length > 0) {
      refineSearchBy('psalm', value);
    }
  });

  $('#toggle-mass-list').click(() => {
    $('#browse-by-mass-list').slideToggle(300);
  });
  $('#browse-by-mass-list a').click(function (e) {
    const value = `${$(this).data('mass-name')}\\${$(this).data('id-mass')}`;

    performSearchBy('mass', value);

    /* hide list when search performed */
    $('#browse-by-mass-list:visible').slideToggle(300);

    e.preventDefault();
  });

  $('#toggle-lls-list').click(() => {
    $('#browse-by-lls-list').slideToggle(300);
  });
  $('#browse-by-lls-list a').click(function (e) {
    const value = `${$(this).data('name')}\\${$(this).data('id-lutheran')}`;

    performSearchBy('lls', value);

    e.preventDefault();
  });

  $('.search-music-results').delegate('.play-sample', 'click', songSample.playSample);

  /* END BROWSE BY */

  function toggleElementWithOtherElement(idToShow, idToHide) {
    if ($(idToShow).is(':visible')) {
      $(idToShow).slideToggle(300);
    } else if ($(`${idToHide}:visible`).length > 0) {
      $(`${idToHide}:visible`).slideToggle(300, () => {
        $(idToShow).slideToggle(300);
      });
    } else {
      $(idToShow).slideToggle(300);
    }
  }

  function performSearchBy(type, value) {
    if (!pendingRequest) {
      currentPage = 1;

      $('#hiddenInputs').html('');

      const inputValue = $('<input>')
          .attr('type', 'hidden')
          .attr('name', 'hidden-value')
          .attr('id', 'hidden-value')
          .val(value);
      const inputType = $('<input>')
          .attr('type', 'hidden')
          .attr('name', 'hidden-type')
          .attr('id', 'hidden-type')
          .val(type);

      $('#hiddenInputs').append(inputValue);
      $('#hiddenInputs').append(inputType);

      $('#searchForm').submit();
    }
  }

  function populateRefineSearchBadges() {
    let html = '';
    let mainFilter = '';
    const data = {};

    $.each(dataArr, (key, value) => {
      data[value.name] = value.value;
    });

    switch (searchType) {
      case 'submit-term':
        mainFilter = decodeURIComponent(data.term.replace(/\+/g, '%20'));
        break;
      default:
        mainFilter = data['hidden-value'];
        break;
    }

    const filters = mainFilter ? jQuery.extend(true, { main: mainFilter }, refineSearch) : refineSearch;

    $.each(filters, (key, value) => {
      if (value !== null && typeof value === 'object') {
        innerKey = Object.keys(value)[0];
        innerValue = value[innerKey];
      } else {
        innerKey = key;
        innerValue = value;
      }

      let text = innerKey == 'psalm' ? 'Psalm: ' : '';

      text += innerValue.split('\\')[0];

      if (key == 'main') {
        html += `<div class="badge">${
                text
            }<i class="badge-delete-button" id="main">X</i>`
            + '</div>';
      } else {
        html += `<div class="badge">${
                text
            }<i class="badge-delete-button" id="${md5(innerKey + innerValue)}">X</i>`
            + '</div>';
      }
    });

    $('#search-term').html(` matching results for <em>${html}</em>`);

    $('.badge-delete-button').click(function () {
      deleteRefineSearchBadges($(this).attr('id'));

      $(this).parent().fadeOut(150, function () {
        $(this).remove();
      });
    });
  }

  function refineSearchBy(type, value) {
    const data = {};
    data[type] = value;

    refineSearch[md5(type + value)] = data;
  }

  function deleteRefineSearchBadges(elem) {
    if (elem == 'main') {
      delete refineSearch[elem];
      $('input[name="term"]').val('');
      $('input[name="hidden-value"]').val('');
      $('#hidden-type').val('');
    } else {
      delete refineSearch[elem];
    }

    $('#searchForm').submit();
  }

  function refineByArray(type, array) {
      $.each(array, (key, value) => {
          refineSearchBy(type, value);
      });
  }

  function isFormFilled() {
    return !!($('input[name="term"]').val() || $('input[name="hidden-value"]').val());
  }
});
